import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@commenda/kakashi';
import { AffiliateAiPromptHelper } from './AffiliateAiPromptHelper';

interface AffiliateClientPickerProps {
  /** Pre-sorted by `useAffiliateAiClient`; supplied by the owning page so the picker shares the
   * page's single selection state instead of holding a hook copy of its own. */
  clients: { id: number; name: string }[];
  /** Null is "All clients" (firm scope). */
  clientId: number | null;
  onClientChange: (clientId: number | null) => void;
}

/** Header control choosing the scope the affiliate AI surface is talking about: every client the
 * member can see, or one of them. Fully controlled: renders what it is given and reports picks
 * upward, never touching the global workspace config. */
const AffiliateClientPicker = ({
  clients,
  clientId,
  onClientChange,
}: AffiliateClientPickerProps) => (
  <Select
    value={
      clientId === null
        ? AffiliateAiPromptHelper.ALL_CLIENTS_PARAM_VALUE
        : String(clientId)
    }
    onValueChange={(value: string) =>
      onClientChange(
        value === AffiliateAiPromptHelper.ALL_CLIENTS_PARAM_VALUE
          ? null
          : Number(value)
      )
    }
  >
    {/* No spacing token reaches 288px (the scale tops out at 10rem), so the raw width stays. */}
    <SelectTrigger className="w-72">
      <SelectValue placeholder="Select a client" />
    </SelectTrigger>
    <SelectContent>
      <SelectItem value={AffiliateAiPromptHelper.ALL_CLIENTS_PARAM_VALUE}>
        All clients
      </SelectItem>
      {clients.map((client) => (
        <SelectItem key={client.id} value={String(client.id)}>
          {client.name}
        </SelectItem>
      ))}
    </SelectContent>
  </Select>
);

export default AffiliateClientPicker;
